interface MenuSectionArgs {
    children?: Array<MenuSection>;
    displayName?: string;
    expirationMin?: number;
    externalUrl?: string;
    id?: string;
    pageHeader?: string;
    sectionId?: string;
    sectionUrl?: string;
    sectionUrlType?: string;
    sortOrder?: number;
    totalLevels?: number;
}

class MenuSection {
    public children: Array<MenuSection> = [];
    public displayName = '';
    public displaySubtitle = '';
    public expirationMin = 0;
    public externalUrl = '';
    public id = '';
    public pageHeader = '';
    public sectionId = '';
    public sectionUrl = '';
    public sectionUrlType = '';
    public sortOrder = 0;
    public totalLevels = 0;
    public isForcePush?: boolean = false;

    constructor(kwargs: MenuSectionArgs) {
        Object.assign(this, kwargs);
    }
}

export default MenuSection;
